import { render, staticRenderFns } from "./centerPaymentList.vue?vue&type=template&id=b780ce58&scoped=true&"
import script from "./centerPaymentList.vue?vue&type=script&lang=js&"
export * from "./centerPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./centerPaymentList.vue?vue&type=style&index=0&id=b780ce58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b780ce58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
